import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Mozambique`}</h3>
    <p>{`When Cyclone Idai struck the country and floods washed away an estimated 400,000 hectares of crops in early 2019, WFP deployed quickly to assess damages and needs, providing the most vulnerable with food and vouchers. In addition, WFP helped plan recovery, reconstruction and resilience-building activities. Thanks to support from donors like the EU, WFP was able to assist `}<a parentName="p" {...{
        "href": "https://www.wfp.org/operations/annual-country-report/?operation_id=MZ01&year=2019#/14980"
      }}>{`2.7 million`}</a>{` people affected by the cyclone and floods during the emergency response.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      